import { useNavigate } from "react-router";
import "./About.css";

export default function About() {
    const navigate = useNavigate();

    const handleContactClick = () => {
        navigate("/contact");
    }

    const handleShopClick = () => {
        navigate("/shop");
    }

    return (
        <section className="about">
            <div className="left">
                <p id="tag">About Quaking Aspen 3D Printing</p>
                <h2>Built for Adventurers, Makers, and Storytellers</h2>
                <p>Quaking Aspen 3D Printing is a family-owned business founded from a love of tabletop gaming, fantasy worlds, and handcrafted creativity. What started as a passion project quickly evolved into a workshop dedicated to creating immersive accessories and display pieces for gamers, collectors, and cosplayers.</p>
                <p>Every dice tower, dungeon tile, and fantasy prop is designed with detail, durability, and imagination in mind. We believe tabletop gear should feel legendary -- whether it lives on a gaming table, convention floor, or collector shelf.</p>
                <div className="button-container">
                    <button onClick={handleShopClick}>Explore the Shop</button>
                    <button onClick={handleContactClick}>Contact the Workshop</button>
                </div>
            </div>
            <div className="right">
                <div className="right-top">
                    <h3>Our Mission</h3>
                    <p>To create premium fantasy-inspired prints that make tabletop adventures feel more immersive and memorable.</p>
                </div>
                <div className="middle">
                    <div className="middle-left">
                        <h2>50+</h2>
                        <h4>Print Designs</h4>
                        <p>Unique prints crafted for gamers and creators.</p>
                    </div>
                    <div className="middle-right">
                        <h2>Endless</h2>
                        <h4>Imagination</h4>
                        <p>Fantasy-inspired designs built with passion and creativity.</p>
                    </div>
                </div>
                <div className="right-bottom">
                    <h5>Crafted with Passion</h5>
                    <p>Every project is carefully printed, assembled, and inspected to ensure it meets the standards of fellow gamers, collectors, and fantasy enthusiasts.</p>
                </div>
            </div>
            <div className="bottom">
                <div className="bottom-left">
                    <div className="icon">⚒️</div>
                    <h3>Peerless Quality</h3>
                    <p>Prints are carefully prepared, cleaned, and finished for display-worthy quality.</p>
                </div>
                <div className="bottom-middle">
                    <div className="icon">🎲</div>
                    <h3>Tabletop Focused</h3>
                    <p>Designed specifically for RPG players, dungeon masters, and immersive game nights.</p>
                </div>
                <div className="bottom-right">
                    <div className="icon">🗡️</div>
                    <h3>Fantasy Inspired</h3>
                    <p>From prop weapons to terrain pieces, everything is crafted to feel epic and immersive.</p>
                </div>
            </div>
            
        </section>
    )
}